import React, { Fragment } from 'react';
import walkingaccess from '../../../../../images/walkingaccessByWard.png';
import '../../driverFaq.css';

const WalkingAccess = () => (
  <Fragment>
    <p>
      The public parking elevator can be accessed via the door on the left
      of the car entrance on George St. Enter the door and take the
      elevator to P4. Once you arrive at P4, turn left, and you will see
      the Autzu cars.
    </p>
    <br />
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={walkingaccess} />
    </div>
    <br />
    <p>
      We do not currently offer free public parking for those who drive a
      personal vehicle to our hub. Please pay for parking if you are
      driving your personal vehicle to our location. Once a driver accesses
      the vehicle, they will be able to exit the facility using the keycard
      attached to the visor.
    </p>
  </Fragment>
);

export default WalkingAccess;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/Metcalfe/WalkingAccess.js